export default {
  leftAvailable: 'Restant allouable',
}
